import { DriverDailyMetricsService } from '@/backend/market'
import moment from 'moment'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { DriverDailyMetricEntity } from '../../domain/entities/DriverDailyMetricEntity'
import type { DriverDailyMetricFilterEntity } from '../../domain/entities/DriverDailyMetricFilterEntity'
import type { DriverDailyMetricManualRunEntity } from '../../domain/entities/DriverDailyMetricManualRunEntity'
import { DriverDailyMetricRepository } from '../../domain/repositories/DriverDailyMetricRepository'
import { DriverDailyMetricFilterModel } from '../models/DriverDailyMetricFilterModel'
import { DriverDailyMetricModel } from '../models/DriverDailyMetricModel'

export class DriverDailyMetricRepositoryImpl implements DriverDailyMetricRepository {
  async getDriverDailyMetrics(
    filterData: DriverDailyMetricFilterEntity
  ): Promise<PaginateEntity<DriverDailyMetricEntity[]> | { error: true }> {
    const filterModel = new DriverDailyMetricFilterModel(filterData)

    try {
      const response = await DriverDailyMetricsService.getDriverDailyMetricsAdmin(filterModel)
      const items = response.items?.map((item) => new DriverDailyMetricModel(item))
      return new PaginateEntity<DriverDailyMetricEntity[]>(
        {
          count: response.count,
          page: response.page ? response.page - 1 : 0,
          limit: response.limit,
          items
        },
        items as unknown as DriverDailyMetricEntity[]
      )
    } catch {
      return { error: true }
    }
  }

  async validateRunDriverDailyMetricsManually(
    data: DriverDailyMetricManualRunEntity
  ) {
    try {
      return await DriverDailyMetricsService.validateRunDriverDailyMetricsManuallyAdmin({
        requestBody: {
          startDate: moment(data.startDate).format('YYYY-MM-DD'),
          endDate: moment(data.endDate).format('YYYY-MM-DD')
        }
      })
    } catch {
      return { error: true } as const
    }
  }

  async runDriverDailyMetricsManually(data: DriverDailyMetricManualRunEntity) {
    try {
      await DriverDailyMetricsService.runDriverDailyMetricsManuallyAdmin({
        requestBody: {
          startDate: moment(data.startDate).format('YYYY-MM-DD'),
          endDate: moment(data.endDate).format('YYYY-MM-DD')
        }
      })
      return true as const
    } catch {
      return { error: true } as const
    }
  }
}
